import request from "./request";
import apis from "./apis";

const {
  permissionInfo,
  rolePermissionInfo,
} = apis.permission;

const permission = {
  getPermissionTreeInfo: () => {
    return request.get(permissionInfo);
  },
  updateRolePermissionInfo: (data: Object) => {
    return request.post(permissionInfo, data);
  },
  getRolePermissionInfo: (data: Object) => {
    return request.get(rolePermissionInfo, data);
  },
};

export default permission;